"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _ShopContext = _interopRequireDefault(require("../../../context/ShopContext"));
var _formatAddress = _interopRequireDefault(require("../../../utils/formatAddress"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Contact = _interopRequireDefault(require("./Contact.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Contact = _ref => {
  let {
    lang = "de"
  } = _ref;
  const {
    shopData
  } = (0, _react.useContext)(_ShopContext.default);
  const {
    addition,
    city,
    company,
    countryCode,
    countryTitle,
    mail,
    phone,
    street,
    zip
  } = shopData || {};
  const address = (0, _formatAddress.default)({
    countryTitle,
    countryCode,
    street,
    town: city,
    zipCode: zip
  });
  const css = (0, _Contact.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.contact, "mco-shop-confirmation-contact")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.headline, "mco-shop-confirmation-contact__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.confirmation.contact.headline",
    l: l
  }), ":"), company && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, company), addition && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, addition), address && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    dangerouslySetInnerHTML: {
      __html: address
    },
    variant: "body2"
  }), mail && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.mail,
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(mail)
  }, mail)), phone && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:".concat(phone.replace(/ /g, ""))
  }, phone)));
};
Contact.propTypes = {
  lang: _propTypes.default.string
};
var _default = exports.default = Contact;